const events = {
  reportCrash: {
    key: 'reportCrash',
    name: '页面崩溃',
    params: {
      trace_id: 'trace_id',
      error: '错误信息',
    },
  },
  reportError: {
    key: 'reportError',
    name: '上报错误',
    params: {
      title: '标题',
      error: '错误',
      message: '信息',
    },
  },
  unhandledrejection: {
    key: 'unhandledrejection',
    name: '未处理异常',
    params: {
      message: '错误信息',
    },
  },
  iframeLoad: {
    key: 'iframeLoad',
    name: 'iframe加载事件',
    params: {
      src: 'iframe地址',
      status: '加载状态', // 0成功 1失败
    },
  },
  ignoreTimeout: {
    key: 'ignoreTimeout',
    name: '忽略超时的接口',
    params: {
      url: '接口地址',
      timeout: '超时时间',
      isTimeout: '是否超时',
    },
  },
  callCenter: {
    key: 'callCenter',
    name: '呼叫中心',
    params: {
      status: '是否成功状态',
      code: '错误code',
      message: '错误message',
      mode: '客户端mode',
      appId: 'appId',
      kfext: 'kfext',
      ticket: 'ticket',
    },
  },
};

export default events;
